import { useEffect, useState } from "react"
import { PrintTransaction } from "components"
import { useFormContext } from "react-hook-form"
import moment from "moment"
import type { FormInvoiceType } from "../types"
import { useCountryById, useHandleAuth, useProvinceById, useRegencyById, useSubdistrictById } from "utils"
import { useList } from "pages/Setup/Preference/SettingCompany/utils/hooks"
import { useSubdomainSetting } from "pages/Purchase/Transaction/PurchaseOrder/utils"
import { useCustomerDetail } from "../../CustomerOrder/utils/hooks"
import { Logo } from "assets"
import { PrintContent } from "./ContentPrint"

export function Print(): JSX.Element {
  const { formState: { defaultValues } } = useFormContext<FormInvoiceType>()

  // state
  const [withImagePrint, setWithImagePrint] = useState<boolean>(false)
  const [withValue, setWithValue] = useState<boolean>(false)

  const company = useList()
  const country = useCountryById()
  const customer = useCustomerDetail(defaultValues?.customer_id ?? "")
  const province = useProvinceById()
  const regency = useRegencyById()
  const setting = useSubdomainSetting()
  const subdistrict = useSubdistrictById()
  const { userTokenData } = useHandleAuth()
  const [address, setAddress] = useState<string>("")
  const [companyLogo, setCompanyLogo] = useState<string>("")

  const userToken = userTokenData()

  const getAddress = (): string => {
    let generateAddress = address ?? ""

    if (subdistrict.data) {
      generateAddress += ", " + subdistrict.data.subdistrict_name
    }

    if (regency.data) {
      generateAddress += ", " + regency.data.regency_name
    }

    if (province.data) {
      generateAddress += ", " + province.data.province_name
    }

    if (country.data) {
      generateAddress += ", " + country.data.country_name
    }

    return generateAddress
  }

  useEffect(() => {
    company.fetchData().then((res) => {
      setCompanyLogo(res.logo_path ?? "")
      setAddress(res.address)

      if (res.subdistrict_id) {
        subdistrict.fetchData(res.subdistrict_id)
      }

      if (res.regency_id) {
        regency.fetchData(res.regency_id)
      }

      if (res.province_id) {
        province.fetchData(res.province_id)
      }

      if (res.country_id) {
        country.fetchData(res.country_id)
      }
    })

    // eslint-disable-next-line
  }, [])

   const logoPath = `${process.env.REACT_APP_BASE_URL_API}/getimage/?imgpath=${companyLogo}`

  return (
    <PrintTransaction
      loading={company.isLoading || customer.isLoading || country.isLoading || province.isLoading || subdistrict.isLoading || regency.isLoading}
      withImagePrint={defaultValues?.approval_status === 4}
      setWithImagePrint={setWithImagePrint}
      setWithValue={setWithValue}
    >
      <section className="flex flex-col gap-3">
        <div className="relative flex items-center mt-6 mb-8">
          <img
            src={logoPath ?? Logo}
            alt="logo"
            className="w-20 absolute left-0"
          />

          <div className="w-full text-center text-2xl font-bold uppercase">
            {userToken?.company_name}
          </div>
        </div>


        <section className="grid grid-cols-2 items-stretch gap-1">
          <section className="font-bold">
            <table className="table-top">
              <tbody className="font-bold">
                <tr>
                  <td className="pr-2">ADDRESS</td>
                  <td>: {getAddress()}</td>
                </tr>

                <tr>
                  <td>PHONE</td>
                  <td>
                    {" "}
                    : {setting.data?.phone ? setting.data?.phone : "-"}
                  </td>
                </tr>

                <tr>
                  <td>EMAIL</td>
                  <td>
                    {" "}
                    : {setting.data?.email ? setting.data?.email : "-"}
                  </td>
                </tr>

                <tr>
                  <td>WEBSITE</td>
                  <td>
                    : {setting.data?.website ? setting.data?.website : "-"}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>

          <section className="flex flex-col justify-between items-end">
            <div className="text-2xl font-bold text-right">
              INVOICE
            </div>

            <table>
              <tbody className="font-bold ">
                <tr>
                  <td width={10} className="text-right">
                    DATE :{" "}
                  </td>
                  <td className="whitespace-nowrap text-right">
                    {defaultValues?.transaction_date
                      ? moment(defaultValues?.transaction_date).format(
                        "DD/MM/YYYY"
                      )
                      : "-"}
                  </td>
                </tr>

                <tr>
                  <td width={10} className="whitespace-nowrap">
                    INVOICE ID :{" "}
                  </td>
                  <td className="whitespace-nowrap text-right">
                    {defaultValues?.trx_code}
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>

        {/* <table className="table table-bordered">
          <TableHeader>
            <tr className="bg-black text-white">
              <th>#</th>
              {withImagePrint &&
                defaultValues?.approval_status === 4 &&
                <th>PICTURE</th>
              }
              <th>DESCRIPTION</th>
              <th>ORDER</th>
              <th>BACKORDER</th>
              <th>SHIPPED</th>
              <th>UNIT</th>
            </tr>
          </TableHeader>

          <tbody>
            {defaultValues?.invoice_detail?.map((item: any, key) => {
              const totalBackOrder = (item?.qty_order ?? 0) - (item?.delivered ?? 0)
              const totalBackOrderInvoice = (item?.qty_order ?? 0) - (item?.quantity_invoice ?? 0)
              const imagePath = `${process.env.REACT_APP_BASE_URL_API}/getimage/?imgpath=${item.product_foto}`

              return (
                <tr>
                  <td className="text-center">{key + 1}</td>
                  {withImagePrint &&
                    defaultValues?.approval_status === 4 &&
                    <td width={150}>
                      <img
                        width={150}
                        height={150}
                        src={imagePath}
                        alt={item?.description}
                      />
                    </td>
                  }
                  <td>
                    <div className="mb-4">{item?.description}</div>
                  </td>
                  <td className="text-right">
                    {convertNumber(item?.qty_order ?? 0).intoCurrency}
                  </td>
                  <td className="text-right">
                    {
                      defaultValues.approval_status !== 4 ?
                        convertNumber(totalBackOrder).intoCurrency
                        : convertNumber(totalBackOrderInvoice).intoCurrency
                    }
                  </td>
                  <td className="text-right">
                    {convertNumber(item?.quantity_invoice ?? 0).intoCurrency}
                  </td>
                  <td>{item?.mr_unit_name}</td>
                </tr>
              )
            })}
          </tbody>
        </table>

        <section className="grid grid-cols-5 items-stretch gap-5">
          <section className="col-span-2 flex flex-col gap-3">
            <table className="table table-bordered">
              <tbody>
                <tr className="bg-black text-white font-bold">
                  <td>Additional Notes:</td>
                </tr>

                <tr className="min-h-[300px]">
                  <td>{defaultValues?.memo}</td>
                </tr>
              </tbody>
            </table>

            <section>
              <div className="w-full bg-black text-white font-bold">Authorized By</div>
              <div className="h-[100px]" />
              <div>{userToken?.company_name}</div>
            </section>
          </section>
          <div />
        </section> */}

        <PrintContent
          withImagePrint={withImagePrint}
          withValue={withValue}
        />


      </section>
    </PrintTransaction>
  )
}